import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import DDadosItem from "@common/components/ddados/ddados.item";
import Form from "@common/components/validation/form.validation";
import autoBind from "react-autobind";
import { Row, Col, Modal } from "react-bootstrap";
import responderExigenciaSelector from "../store/responderExigencia.selectors";
import responderExigenciaActions from "../store/responderExigencia.actions";
import { ddados } from "../responderExigencia.ddados";
import guid from 'uuid/v1';
import Button from "@material-ui/core/Button";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  async onClose(values) {
    if(values.Arquivo.name) {
      const result = await _alert.confirm('Tem certeza que deseja cancelar a inclusão deste documento?', 'Cancelar inclusão documento');
      if (result) this.props.responderExigenciaActions.toggleDocumentoModal();
    } else {
      this.props.responderExigenciaActions.toggleDocumentoModal();
    }
  }

  onSubmit(values) {
    this.props.responderExigenciaActions.validaUploadDocumentoExigencia(values);
  }

  render() {
    const { Campos } = ddados;
    const { responderExigenciaSelector } = this.props;
    const { responderExigencia } = responderExigenciaSelector;
    const { ShowModalDocumento, FormExigencia } = responderExigencia;
    const { IdAnalise } = FormExigencia;

    return (
      <Modal show={ShowModalDocumento} onHide={this.onClose} size="lg">
        <Form className="box-form-cadastro">
          {form => (
            <Fragment>
              <Modal.Header>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <DDadosItem
                      name="Arquivo"
                      {...Campos.Arquivo}
                      newFileName={`redesim_resposta_exigencia_${IdAnalise}_${guid()}`}
                      onChange={(value, values, fileName) => {
                        if (value)
                          _alert.warning(
                            `Por motivo de segurança o nome do arquivo foi alterado de "${fileName}" para "${value.name}".`
                          );
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <DDadosItem name="DescricaoArquivo" {...Campos.DescricaoArquivo} />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outlined" color="primary" onClick={() => this.onClose(form.values)}>
                  <i className="fa fa-angle-double-left" />&nbsp;Voltar
                </Button>
                &nbsp;
                &nbsp;
                <Button variant="contained" color="primary" onClick={() => this.onSubmit(form.values)}>
                  <i className="fa fa-check" />&nbsp;Confirmar
                </Button>
              </Modal.Footer>
            </Fragment>
          )}
        </Form>
      </Modal>
    )
  };
}

export default connect({
  actions: {
    responderExigenciaActions
  },
  selectors: {
    responderExigenciaSelector
  }
})(Container);
